export const ZENDESK_HELP_CENTER_BASE = "https://support.manifold.ai/hc/en-us";

const ZENDESK_SSO_PREFIX = "/zendesk/sso?return_to=";

export const zendeskUrl = (path: string) => zendeskHelpCenterUrl(`/articles/${path}`);

export const zendeskHelpCenterUrl = (path: "" | `/${string}` = ""): string => {
  const target = path ? `${ZENDESK_HELP_CENTER_BASE}${path}` : ZENDESK_HELP_CENTER_BASE;
  return `${ZENDESK_SSO_PREFIX}${encodeURIComponent(target)}`;
};
